<template>
    <transition name="modal">
        <div class="modal__mask" @click="close" v-show="show">
            <div :class="`modal__container${showLarge ? ' modal__container--large' : ''}`" @click.stop>
                <slot name="modalHeader"></slot>
                <div class="modal__body"><slot></slot></div>
                <slot name="modalFooter"></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'modal',
  props: {
    show: Boolean,
    showLarge: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
    @import "./modal";
</style>



// WEBPACK FOOTER //
// src/components/Modal/modal.vue